/* @flow */

import * as React from 'react';

import Localizer from '../../helpers/localization';
import Credit from './Credit';
import './Credits.css';

type CreditsByRolePropType = {
  +labelKey: string,
  +names: Array<string>,
};

const CreditsByRole = ({ labelKey, names }: CreditsByRolePropType): React.Node => {
  if (names.length === 0) {
    return null;
  }

  /* eslint-disable react/no-array-index-key */
  return (
    <>
      <span className='label'>{Localizer.localize(labelKey)}</span>
      {names.map((name, index) => (
        <Credit key={`${index}-${name}`} name={name} />
      ))}
    </>
  );
  /* eslint-enable react/no-array-index-key */
};

export default CreditsByRole;
